'use client';
import { atom, useAtom, useSetAtom, getDefaultStore, WritableAtom } from 'jotai';
import { IFanConversationSet } from '@ui/components';

export const selectedConversationAtom = atom<IFanConversationSet | null>(null) as WritableAtom<
  IFanConversationSet | null,
  [IFanConversationSet | null],
  void
>;

export const setSelectedConversationAtom = atom(
  null,
  (get, set, selectedConversation: IFanConversationSet | null) => {
    set(selectedConversationAtom, selectedConversation);
  },
);

export const updateSelectedConversationAtom = atom(
  null,
  (get, set, updates: IFanConversationSet) => {
    set(selectedConversationAtom, updates);
  },
);

export const flushSelectedConversationAtom = atom(null, (get, set) => {
  set(selectedConversationAtom, null);
});

// Helper functions to work with selected conversation from outside React components
export function getSelectedConversation(): IFanConversationSet | null {
  const store = getDefaultStore();
  return store.get(selectedConversationAtom);
}

export function updateSelectedConversationFromStore(updates: IFanConversationSet) {
  const store = getDefaultStore();
  store.set(updateSelectedConversationAtom, updates);
}

export function useSelectedConversationState() {
  const [selectedConversation] = useAtom(selectedConversationAtom);
  const setSelectedConversation = useSetAtom(setSelectedConversationAtom);
  const updateSelectedConversation = useSetAtom(updateSelectedConversationAtom);
  const flushSelectedConversation = useSetAtom(flushSelectedConversationAtom);

  return {
    selectedConversation,
    setSelectedConversation,
    updateSelectedConversation,
    flushSelectedConversation,
  };
}
